/*
  Abwesenheiten der Verfügbarkeitsseite im Schichtplan (Zusatzmodul
  employee_absences). Der Server liefert sie schon je Person und Tag zerlegt
  und nur freigegebene (databases/employee_visibility.py) — hier werden sie
  nur noch den Zellen zugeordnet und beschriftet. Reine Anzeige.
*/

import { formatTime } from "../date/month";

export const AVAILABILITY_ABSENCE_LABEL = "Abwesend";

export function getAvailabilityAbsenceTimeLabel(entry) {
  if (entry?.isFullDay) return "Ganztag";
  const start = formatTime(entry?.start);
  const end = formatTime(entry?.end);
  return start && end ? `${start} - ${end}` : "Ganztag";
}

export function getAvailabilityAbsenceTooltip(entry) {
  const parts = [`${AVAILABILITY_ABSENCE_LABEL} · ${getAvailabilityAbsenceTimeLabel(entry)}`];
  if (entry?.comment) parts.push(entry.comment);
  return parts.join(" — ");
}

export function groupAvailabilityAbsencesByCell({ entries, days }) {
  const visibleDayKeys = new Set((Array.isArray(days) ? days : []).map((day) => String(day?.key || "")).filter(Boolean));

  return (Array.isArray(entries) ? entries : []).reduce((accumulator, entry) => {
    const userId = String(entry?.userId || "");
    const dateKey = String(entry?.dateKey || "");
    if (!userId || !dateKey) return accumulator;
    if (visibleDayKeys.size && !visibleDayKeys.has(dateKey)) return accumulator;

    const key = `${userId}::${dateKey}`;
    if (!accumulator[key]) accumulator[key] = [];
    accumulator[key].push(entry);
    return accumulator;
  }, {});
}
